import { render, staticRenderFns } from "./ScreeningInProgressCandidates.vue?vue&type=template&id=c6b27022&scoped=true"
import script from "./ScreeningInProgressCandidates.vue?vue&type=script&lang=js"
export * from "./ScreeningInProgressCandidates.vue?vue&type=script&lang=js"
import style0 from "./ScreeningInProgressCandidates.vue?vue&type=style&index=0&id=c6b27022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b27022",
  null
  
)

export default component.exports